import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=8cd4810e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd4810e')) {
      api.createRecord('8cd4810e', component.options)
    } else {
      api.reload('8cd4810e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=8cd4810e&", function () {
      api.rerender('8cd4810e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QDeX9E4o6ykp/JS/imageCarousel.vue"
export default component.exports